import React, { useContext, useCallback, useMemo } from 'react';
import type { NavigationSlice as NavigationSliceProps } from '../../../../types';
import RouteContext from '../../../../routes/context';
import { NavigationSliceView } from './navigation-component';
import type { FacetLink } from './types';
import { useTrackFilterSelect } from '../../filter-tracking';

const NavigationSlice = (props: NavigationSliceProps) => {
  const { links, property } = props;
  const { dispatch, currentRouteState } = useContext(RouteContext);
  const { trackFilterSelect } = useTrackFilterSelect({
    property: property || '',
    type: 'facet-navigation',
    title: property || '',
  });
  const filter = (currentRouteState.filters || []).find(
    (f: { property: string }) => f.property === property
  );
  const onClick = useCallback(
    (link: FacetLink) => {
      trackFilterSelect({ value: link.id });
      dispatch({
        type: 'FILTER_LIST_UPDATE',
        property,
        id: link.id,
      });
    },
    [property, dispatch, trackFilterSelect]
  );
  const formattedLinks = useMemo(
    () =>
      links?.map((link): FacetLink => {
        const imageUrl = link.productMedia?.first || link.fallbackImage;
        const selected = filter && filter.id === link.id;
        return { ...link, imageUrl, selected };
      }) ?? [],
    [filter, links]
  );
  return (
    <NavigationSliceView
      onClick={onClick}
      links={formattedLinks}
      onClickPreventDefault
    />
  );
};

export default NavigationSlice;
